import React from "react";

const LoadingIcon = ({ height, classname, customHeightClass = false }) => {
  classname = classname ? classname : "";
  classname = classname + " w-full flex justify-center items-center";
  if (!customHeightClass) {
    classname = classname + "  h-full ";
  }

  return (
    <div className={classname}>
      <img
        src="/images/phenobee_loading.svg"
        alt="Loader"
        style={{ height: height ? height : "100px" }}
      />
    </div>
  );
};

export default LoadingIcon;
